import React from "react";
import { ProgressSpinner } from "primereact/progressspinner";
import { useAppLayout } from "./AppLayoutContext";
import "./Loader.css";

export function Loader() {
  const { isLoading } = useAppLayout();

  if (!isLoading) return null;

  return (
    <div className="app-loader-overlay" aria-busy="true" aria-live="polite">
      <div className="app-loader-overlay__backdrop" />
      <div className="app-loader-overlay__content">
        <ProgressSpinner
          style={{ width: "48px", height: "48px" }}
          strokeWidth="4"
        />
      </div>
    </div>
  );
}
